import { apiDelete, apiGet, apiPatch, apiPost } from './client.js';

export type InventoryCategoryNode = {
  id: string;
  name: string;
  slug: string;
  parentId: string | null;
  sortOrder: number | null;
  active: boolean;
  children: InventoryCategoryNode[];
};

export function listInventoryCategories() {
  return apiGet<InventoryCategoryNode[]>('/api/v1/inventory/categories').then((r) => r.data);
}

export function createInventoryCategory(body: {
  name: string;
  slug?: string;
  parentId?: string | null;
  sortOrder?: number;
}) {
  return apiPost<InventoryCategoryNode>('/api/v1/inventory/categories', body).then((r) => r.data);
}

export function patchInventoryCategory(
  id: string,
  body: Partial<{ name: string; slug: string; parentId: string | null; sortOrder: number; active: boolean }>,
) {
  return apiPatch<InventoryCategoryNode>(`/api/v1/inventory/categories/${id}`, body).then(
    (r) => r.data,
  );
}

export function deleteInventoryCategory(id: string) {
  return apiDelete(`/api/v1/inventory/categories/${id}`);
}
